import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const Login = () => {
  const navigate = useNavigate();
  const { user, login, settings } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      // All users are redirected to /admin, which handles role-based access
      navigate('/admin');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Image */}
      <div 
        className="hidden lg:block lg:w-1/2 bg-cover bg-center relative"
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/26200673/pexels-photo-26200673.jpeg)' }}
      >
        <div className="absolute inset-0 bg-slate-900/40"></div>
      </div>

      {/* Right side - Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-background">
        <div className="w-full max-w-md space-y-8">
          {/* Logo */}
          <div className="text-center">
            {settings?.logo_base64 || settings?.logo_url ? (
              <img 
                key={settings?.logo_base64 || settings?.logo_url}
                src={settings?.logo_base64 || `${process.env.REACT_APP_BACKEND_URL}${settings?.logo_url}`}
                alt="Logo" 
                className="h-16 mx-auto mb-4"
              />
            ) : (
              <div className="h-16 w-16 mx-auto mb-4 bg-accent rounded-sm flex items-center justify-center">
                <span className="text-2xl font-secondary font-bold text-white">
                  {settings?.company_name?.substring(0, 2).toUpperCase() || 'CF'}
                </span>
              </div>
            )}
            <h1 className="text-3xl font-secondary font-bold uppercase tracking-tight text-slate-900">
              {settings?.company_name || 'Sistema de Gestão'}
            </h1>
            {settings?.subtitle && (
              <p className="mt-2 text-sm text-slate-600 font-primary">
                {settings.subtitle}
              </p>
            )}
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="mt-8 space-y-6" data-testid="login-form">
            <div className="space-y-4">
              <div>
                <Label htmlFor="email" className="font-secondary uppercase text-xs tracking-wider text-slate-500">
                  E-mail
                </Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1 h-10 rounded-sm border-slate-200 focus:ring-2 focus:ring-slate-900 focus:border-transparent bg-slate-50/50"
                  data-testid="email-input"
                />
              </div>
              <div>
                <Label htmlFor="password" className="font-secondary uppercase text-xs tracking-wider text-slate-500">
                  Senha
                </Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="mt-1 h-10 rounded-sm border-slate-200 focus:ring-2 focus:ring-slate-900 focus:border-transparent bg-slate-50/50"
                  data-testid="password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-10 bg-slate-900 text-white hover:bg-slate-800 rounded-sm font-medium transition-all active:scale-95 shadow-sm"
              data-testid="login-button"
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
